<template>
  <div
    class="modal fade"
    id="hospitalInfoMModal"
    tabindex="-1"
    aria-labelledby="hospitalInfoMModallLabel"
    aria-hidden="true"
    style="overflow-x: hidden"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header text-center">
          <div class="modal_header_flex" >
            <h1 class="modal-title fs-5" id="staticBackdropLabel">
              병원 정보 수정하기
            </h1>
          </div>
        </div>
        <div class="modal-division"/>
        <div class="modal-body" style="padding-top: 1rem">

          <div class="modalDivWrap">
            <div class="modalPartTitle">병원 정보 수정</div>
            <div class="modalInputDiv">
              <label>사업자등록번호<span class="requiredSpan">*</span></label>
              <input
                type="text"
                placeholder="사업자등록 번호를 입력해주세요(ex. 123-45-67890)"
                v-model="businessNumber"
                maxlength="12"
                @input="changeBusinessNumber"
                @keyup.enter="businessNumberValidate"
              />
              <div class="modalInputRight">
                <button
                  class="btn btn-primary modalBtnRight"
                  style="margin-bottom: 0!important;"
                  @click="businessNumberValidate()"
                >
                  중복확인
                </button>
              </div>
            </div>
            <div class="modalInputDiv" style="padding: 0!important">
              <label/>
              <span class="businessNumberMsgM fail"></span>
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label>사업자등록증</label>
              <button 
                class="btn btn-primary"
                @click="openBusinessFileInput()"
                style="margin-bottom: 0!important;"
              >등록증 업로드</button>
              <div v-if="businessFileName" class="fileNameWrap">
                <span 
                  class="imgspan hoverPointer" 
                  style="margin-left: 10px; width: 40%; overflow: hidden;"
                  @click="downloadBusinessNumImage()"
                  >{{ businessFileName }}
                </span>
                <button class="btn-close" 
                @click="deleteBusinessNumImage()"
                style=""/>
              </div>
              <input
              type="file"
              id="businessFileInputM"
              ref="businessFileInputM"
              @change="changeBusinessNumImage()"
              />
            </div>
            <div class="modalInputDiv">
              <label>테스트 병원 여부</label>
              <div class="radioWrap">
                <div class="radioObj">
                  <a-checkbox
                    v-model:checked="isTestCompany"
                    id="isTestCompanyM"
                  />
                </div>
              </div>
            </div>
            <div class="modalInputDiv">
              <label>진료 과목<span class="requiredSpan">*</span></label>
              <div class="radioWrap">
                <div class="radioObj" v-for="(item, i) in deptList" :key="i">
                  <input 
                  type="checkbox" 
                  :value="item.code"
                  :id="item.code+'M'"
                  v-model="medicalDept"
                  /> 
                  <label :for="item.code+'M'">{{ item.name }}</label>
                </div>
              </div>
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label>지역 구분<span class="requiredSpan">*</span></label>
              <select v-model="selectedAreaFirst" style="
                width: 15%;
                border-radius: 5px;
                border-width: 1px;
                height: 35px;" id="itemCode"
                @change="areaSecondChange()"
              >
                <option value="" selected>시/도 선택</option>
                <option v-for="item in areaFirst" :value="item" :key="item">{{ `${item}` }}</option>
              </select>
              <select v-model="selectedAreaSecond" style="
                width: 15%;
                border-radius: 5px;
                border-width: 1px;
                margin-left: 20px;
                height: 35px;" id="itemCode"
                @change="areaThirdChange()"
              >
                <option value="" selected>시/군/구 선택</option>
                <option v-for="item in areaSecond" :value="item" :key="item">{{ `${item}` }}</option>
              </select>
              <select v-model="selectedAreaThird" style="
                width: 15%;
                border-radius: 5px;
                border-width: 1px;
                margin-left: 20px;
                height: 35px;" id="itemCode"
              >
                <option value="" selected>읍/면/동 선택</option>
                <option v-for="item in areaThird" :value="item" :key="item">{{ `${item}` }}</option>
              </select>
            </div>
            <div class="modalInputDiv">
              <label>상세 주소</label>
              <input
                type="text"
                placeholder="나머지 상세주소를 입력하세요."
                v-model="addrDetail"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label>병원명<span class="requiredSpan">*</span></label>
              <input
                type="text"
                placeholder="사업자등록증에 등록된 병원명을 입력하세요."
                v-model="hospitalName"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label>병원장명</label>
              <input
                type="text"
                placeholder="사업자등록증에 등록된 병원장명을 입력하세요."
                v-model="hospitalCeoName"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label>대표 전화번호</label>
              <input
                type="text"
                placeholder="대표 전화번호를 입력해주세요(ex. 02-1234-5678)."
                v-model="hospitalPhoneNumber"
                maxlength="13"
                @input="changeHospitalPhoneNumber"
              />
              <div class="modalInputRight">
      
              </div>
            </div>
            <div class="modalInputDiv">
              <label>요양기관 코드</label>
              <input
                type="text"
                placeholder="병원의 요양기관 코드를 입력해주세요(ex.11111111)."
                v-model="hospitalCode"
              />
              
              <div class="modalInputRight">
              </div>
            </div>
             <div class="modalInputDiv" style="align-items: start;">
              <label style="margin-top: 10px;">재직 의사</label>
              <div class="rowsWrap">
                <div 
                class="doctorRow"
                v-for="(item, i) in doctors"
                >
                  <div class="doctorInput">
                    <input 
                    type="text" 
                    placeholder="병원에 재직중인 의사 이름을 입력해주세요."
                    v-model="doctors[i]"
                    />
                  </div>
                  <div class="modalInputRight">
                    <button 
                    v-if="i===doctors.length-1"
                    class="btn btn-primary modalBtnRight" 
                    style="margin-bottom: 0!important;" 
                    @click="addRow()">
                      +
                    </button>
                    <button 
                    v-if="i>0 || doctors.length > 1"
                    class="btn btn-primary modalBtnRight" 
                    style="margin-bottom: 0!important;" 
                    @click="deleteRow(i)">
                      -
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div style="padding: 10px 0; display: flex; justify-content: center;"/>
            <div class="modalInputDiv">
              <label>페이지 로고</label>
              <button 
                class="btn btn-primary"
                @click="openLogoFileInput()"
                style="margin-bottom: 0!important;"
              >이미지 업로드</button>
              <input
              type="file"
              id="logoFileInputM"
              accept="image/jpeg, image/png"
              ref="logoFileInputM"
              @change="changeLogoImage()"
              />
            </div>
            <div class="modalInputDiv">
              <label/>
              <div class="logoFileNameWrap">
                <span class="imgspan"
                > 
                <img src="#" alt="" id="logoPrevM" class="hoverPointer" @click="downloadLogoImage()" />
                </span>
                <div v-if="logoFileName">
                  <span 
                  class="imgspan hoverPointer"
                  @click="downloadLogoImage()"
                  >{{logoFileName}}</span>
                  <button class="btn-close" 
                  @click="deleteLogoImage()"
                  style=""/>
                </div>
              </div>
            </div>
            <div class="modalInputDiv">
              <label/>
              <div class="modalTextSmall">
                이미지 권장 사이즈는 300*60입니다. 파일 크기는 최대 100MB까지 등록 가능합니다.
              </div>
            </div>
            <div style="padding: 10px 0; display: flex; justify-content: center;"/>
            <div class="modalInputDiv">
              <label>배너 이미지</label>
              <button 
                class="btn btn-primary"
                @click="openBannerFileInput()"
                style="margin-bottom: 0!important;"
              >이미지 업로드</button>
              <input
              type="file"
              id="bannerFileInputM"
              accept="image/jpeg, image/png"
              ref="bannerFileInputM"
              @change="changeBannerImage()"
              />
            </div>
            <div class="modalInputDiv">
              <label/>
              <div class="logoFileNameWrap">
                <span class="imgspan"
                > 
                <img src="#" alt="" id="bannerPrevM" class="hoverPointer" @click="downloadBannerImage()" />
                </span>
                <div v-if="bannerFileName">
                  <span 
                  class="imgspan hoverPointer"
                  @click="downloadBannerImage()"
                  >{{bannerFileName}}</span>
                  <button class="btn-close" 
                  @click="deleteBannerImage()"
                  style=""/>
                </div>
              </div>
            </div>
            <div class="modalInputDiv">
              <label/>
              <div class="modalTextSmall">
                이미지 권장 사이즈는 300*60입니다. 파일 크기는 최대 100MB까지 등록 가능합니다.
              </div>
            </div>
            
          </div>
          <div class="modalDivWrap">
            <div class="modalPartTitle">관리자 정보 수정</div>
            <div class="modalInputDiv"/>
            <div class="modalInputDiv">
              <label>관리자 이름</label>
              <input
                type="text"
                placeholder="해당 병원의 관리자 이름을 입력해주세요."
                v-model="managerName"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label>관리자 직급</label>
              <input
                type="text"
                placeholder="관리자의 직급을 입력해주세요."
                v-model="managerDuty"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label>관리자 연락처</label>
              <input
                type="text"
                placeholder="관리자의 연락처를 입력해주세요."
                v-model="managerPhoneNumber"
                maxlength="13"
                @input="changeManagerPhoneNumber"
                />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label>관리자 아이디</label>
              <span style="color: black;">{{ managerId }}</span>
              <div class="modalInputRight"/>
            </div>
          </div>

          <!-- 웹챗봇 설정 섹션 -->
          <div class="modalDivWrap">
            <div class="modalPartTitle">웹챗봇 설정</div>
            <div class="modalInputDiv">
              <label>
                예약 페이지 내 웹챗봇 사용
                <a-tooltip placement="top">
                  <template #title>
                    활성화 시, 예약 페이지에 웹챗봇 위젯이 표시됩니다.
                  </template>
                  <QuestionCircleOutlined style="margin-left: 5px; color: #999; cursor: help;" />
                </a-tooltip>
              </label>
              <a-switch
                v-model:checked="useWebChatbotOnReservation"
                @change="onUseWebChatbotChange"
              />
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv" v-if="useWebChatbotOnReservation">
              <label>
                내 챗봇 사용하기
                <a-tooltip placement="top">
                  <template #title>
                    활성화 시, 기본 챗봇 대신 병원 소유의 챗봇을 사용합니다.
                  </template>
                  <QuestionCircleOutlined style="margin-left: 5px; color: #999; cursor: help;" />
                </a-tooltip>
              </label>
              <a-switch
                v-model:checked="useOwnChatbot"
                :disabled="chatbotList.length === 0"
                @change="onUseOwnChatbotChange"
              />
              <span v-if="chatbotList.length === 0" style="margin-left: 10px; color: #999; font-size: 12px;">
                (등록된 챗봇이 없습니다)
              </span>
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv" v-if="useWebChatbotOnReservation && useOwnChatbot">
              <label>챗봇 선택</label>
              <select
                v-model="mainChatbotId"
                style="width: 70%; border-radius: 5px; border-width: 1px; height: 35px;"
              >
                <option value="">챗봇을 선택해주세요</option>
                <option
                  v-for="chatbot in chatbotList"
                  :value="chatbot._id"
                  :key="chatbot._id"
                >
                  {{ chatbot.name }}
                </option>
              </select>
              <div class="modalInputRight"/>
            </div>
          </div>

          <!-- 외부 서비스 연동 섹션 -->
          <div class="modalDivWrap">
            <div class="modalPartTitle">외부 서비스 연동</div>

            <div class="modalInputDiv">
              <label>외부 서비스 구분</label>
              <select
                v-model="selectedServiceType"
                @change="onServiceTypeChange"
                style="width: 70%; border-radius: 5px; border-width: 1px; height: 35px;"
              >
                <option value="">서비스 구분을 선택해주세요</option>
                <option
                  v-for="type in externalServiceTypes"
                  :value="type._id"
                  :key="type._id"
                >
                  {{ type.name }}
                </option>
              </select>
              <div class="modalInputRight">
                <button
                  type="button"
                  class="btn btn-primary modalBtnRight"
                  style="margin-bottom: 0!important;"
                  @click="openServiceTypeModal()"
                >
                  추가
                </button>
              </div>
            </div>

            <!-- 서비스 타입 추가 입력 필드 -->
            <div class="modalInputDiv" v-if="showServiceTypeInput">
              <label></label>
              <input
                type="text"
                placeholder="새 서비스 타입명을 입력하세요"
                v-model="newServiceTypeName"
                @keyup.enter="saveServiceType()"
              />
              <div class="modalInputRight">
                <button
                  type="button"
                  class="btn btn-success modalBtnRight"
                  style="margin-bottom: 0!important; margin-right: 5px;"
                  @click="saveServiceType()"
                >
                  저장
                </button>
                <button
                  type="button"
                  class="btn btn-secondary modalBtnRight"
                  style="margin-bottom: 0!important;"
                  @click="cancelServiceTypeInput()"
                >
                  취소
                </button>
              </div>
            </div>

            <div class="modalInputDiv">
              <label>연동 서비스</label>
              <select
                v-model="selectedService"
                :disabled="!selectedServiceType"
                @change="onServiceChange"
                style="width: 70%; border-radius: 5px; border-width: 1px; height: 35px;"
              >
                <option value="">연동 서비스를 선택해주세요</option>
                <option
                  v-for="service in externalServices"
                  :value="service._id"
                  :key="service._id"
                >
                  {{ service.name }}
                </option>
              </select>
              <div class="modalInputRight">
                <button
                  type="button"
                  class="btn btn-primary modalBtnRight"
                  style="margin-bottom: 0!important;"
                  @click="openProviderModal()"
                  :disabled="!selectedServiceType"
                >
                  추가
                </button>
              </div>
            </div>

            <!-- 제공자 추가 입력 필드 -->
            <div class="modalInputDiv" v-if="showProviderInput">
              <label></label>
              <input
                type="text"
                placeholder="새 제공자명을 입력하세요"
                v-model="newProviderName"
                @keyup.enter="saveProvider()"
              />
              <div class="modalInputRight">
                <button
                  type="button"
                  class="btn btn-success modalBtnRight"
                  style="margin-bottom: 0!important; margin-right: 5px;"
                  @click="saveProvider()"
                >
                  저장
                </button>
                <button
                  type="button"
                  class="btn btn-secondary modalBtnRight"
                  style="margin-bottom: 0!important;"
                  @click="cancelProviderInput()"
                >
                  취소
                </button>
              </div>
            </div>

            <!-- 스케줄 종류 (DOCTOR_PALETTE 전용) -->
            <div class="modalInputDiv" v-if="showScheduleTypeSelect">
              <label>스케줄 종류</label>
              <select
                v-model="selectedScheduleType"
                style="width: 60%; border-radius: 5px; border-width: 1px; height: 35px;"
              >
                <option value="">스케줄 종류를 선택해주세요</option>
                <option
                  v-for="schedule in scheduleTypes"
                  :value="schedule.id"
                  :key="schedule.id"
                >
                  {{ schedule.name }}
                </option>
              </select>
              <div class="modalInputRight">
                <button
                  type="button"
                  class="btn btn-primary modalBtnRight"
                  style="margin-bottom: 0!important;"
                  @click="fetchScheduleTypes()"
                >
                  조회
                </button>
              </div>
            </div>

            <!-- 예약연동활성화 (DOCTOR_PALETTE 전용) -->
            <div class="modalInputDiv" v-if="showScheduleTypeSelect">
              <label>
                예약연동활성화
                <a-tooltip placement="top">
                  <template #title>
                    활성화 시, 닥터팔레트의 예약 가능 시간이 우선 적용됩니다. 닥터팔레트에서 예약 불가한 시간대는 서티라이프에서도 예약이 제한됩니다.
                  </template>
                  <QuestionCircleOutlined style="margin-left: 5px; color: #999; cursor: help;" />
                </a-tooltip>
              </label>
              <a-switch
                v-model:checked="useExternalSchedule"
              />
              <div class="modalInputRight"/>
            </div>

            <div class="modalInputDiv">
              <label>API 키</label>
              <div style="position: relative; width: 70%;">
                <input
                  :type="showApiKey ? 'text' : 'password'"
                  placeholder="API 키를 입력해주세요"
                  v-model="apiKey"
                  style="width: 100%; padding-right: 45px;"
                />
                <button
                  type="button"
                  @click="toggleShowApiKey()"
                  style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer; padding: 5px; font-size: 16px; color: #999;"
                >
                  <EyeOutlined v-if="showApiKey" />
                  <EyeInvisibleOutlined v-else />
                </button>
              </div>
              <div class="modalInputRight"/>
            </div>

            <div class="modalInputDiv">
              <label>클라이언트 ID</label>
              <div style="position: relative; width: 70%;">
                <input
                  :type="showClientId ? 'text' : 'password'"
                  placeholder="클라이언트 ID를 입력해주세요"
                  v-model="clientId"
                  style="width: 100%; padding-right: 45px;"
                />
                <button
                  type="button"
                  @click="toggleShowClientId()"
                  style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer; padding: 5px; font-size: 16px; color: #999;"
                >
                  <EyeOutlined v-if="showClientId" />
                  <EyeInvisibleOutlined v-else />
                </button>
              </div>
              <div class="modalInputRight"/>
            </div>

            <div class="modalInputDiv">
              <label>클라이언트 시크릿</label>
              <div style="position: relative; width: 70%;">
                <input
                  :type="showClientSecret ? 'text' : 'password'"
                  placeholder="클라이언트 시크릿을 입력해주세요"
                  v-model="clientSecret"
                  style="width: 100%; padding-right: 45px;"
                />
                <button
                  type="button"
                  @click="toggleShowClientSecret()"
                  style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer; padding: 5px; font-size: 16px; color: #999;"
                >
                  <EyeOutlined v-if="showClientSecret" />
                  <EyeInvisibleOutlined v-else />
                </button>
              </div>
              <div class="modalInputRight"/>
            </div>

            <div style="padding: 10px 0; display: flex; justify-content: center;">
              <button
                type="button"
                class="btn btn-info"
                style="width: 150px;"
                @click="registerExternalService()"
              >
                등기화
              </button>
            </div>
          </div>
        </div>
        <!-- 운영자 회사 강제 스위치(C8, REQ-ACC-012) -->
        <div class="px-4">
          <company-two-factor-policy-switch :company-id="hospitalId" />
          <!-- 고객 지원을 위한 접근(동의 스위치·지원 계정·지원 접속 — W6 A3) -->
          <support-access-card :company-id="hospitalId" company-type="HOSPITAL" :company-name="hospitalName" />
        </div>
        <div class="modal-footer" style="justify-content: center">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            style="color: #666666; background: #fff; border: 1px solid #666;"
          >
            취소
          </button>
          <button
            type="button"
            class="btn btn-info"
            @click="modifyHospital()"
          >
            수정하기
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CompanyTwoFactorPolicySwitch from "@/views/components/CompanyTwoFactorPolicySwitch.vue";
import SupportAccessCard from "@/views/components/SupportAccessCard.vue";
import { openDialog, decodeUtfText, changeBytesToKilos, businessNumberFormatter, phoneNumberFormatter } from "@/utils/utils";
import jsonFile from "@/assets/locations.json";
import {
  MedicalDept,
} from '@/utils/enums'
import {
  YnEnum
} from '@/enums/common.enums'
import { EyeOutlined, EyeInvisibleOutlined, QuestionCircleOutlined } from '@ant-design/icons-vue'
import externalServiceMixin from '@/mixins/externalServiceMixin'

export default {
  components: {
    EyeOutlined,
    EyeInvisibleOutlined,
    QuestionCircleOutlined,
    CompanyTwoFactorPolicySwitch,
    SupportAccessCard,
  },
  mixins: [externalServiceMixin],
  data() {
    return {
      type: "HOSPITAL", 

      hospitalId: "", // 병원Id

      deptList: [], // 병원 구분
      areaFirst: [], // 시군구 대분류
      areaSecond: [], // 시군구 중분류
      areaThird: [], // 읍면동 소분류
      selectedAreaFirst: "", // 선택된 시군구 대분류
      selectedAreaSecond: "", // 선택된 시군구 중분류
      selectedAreaThird: "", // 선택된 읍면동 소분류
      addrDetail: "", // 주소 상세
      medicalDept: [], // 선택된 병원구분
      
      hospitalName: "", // 병원명
      hospitalCeoName: "", // 병원장명
      hospitalPhoneNumber: "", // 병원명
      hospitalCode: "", // 요양기관 코드
      doctors: [""], // 재직 의사
      businessNumber: "", // 사업자등록번호
      originalBusinessNumber: '', // 사업자등록번호

      managerName: "", // 관리자 이름
      managerDuty: "", // 관리자 직급
      managerPhoneNumber: "", // 관리자 연락처
      managerId: "", // 관리자 아이디

      businessFileName: "", // 사업자이미지 파일명
      businessFileData: null, // 실제 사업자이미지파일 정보가 담긴 폼데이터
      businessImgUrl: "", // objectStorage 상 사업자이미지 url

      logoFileName: "", // 로고이미지 파일명
      logoFileData: null, // 실제 로고파일 정보가 담긴 폼데이터
      logoImgUrl: "", // objectStorage 상 로고이미지 url

      bannerFileName: "", // 배너이미지 파일명
      bannerFileData: null, // 실제 배너이미지파일 정보가 담긴 폼데이터
      bannerImgUrl: "", // objectStorage 상 배너이미지 url

      // 검증관련 불리언, 필수값에 따라 추가 -> 최초에 등록됐던 값은 유효한 것으로 판단
      isBusinessNumberValid: true,
      isTestCompany: false,
      // 외부 서비스 관련 데이터는 externalServiceMixin에서 관리

      // 웹챗봇 설정
      useWebChatbotOnReservation: false,
      useOwnChatbot: false,
      mainChatbotId: "",
      chatbotList: [],
    };
  },
  props: {
    data: {
      hospitalId: {
        type: String,
        required: false
      },
      deptList: {
        type: Array,
        required: false
      },
      areaFirst: {
        type: Array,
        required: false
      },
      areaSecond: {
        type: Array,
        required: false
      },
      areaThird: {
        type: Array,
        required: false
      },
      selectedAreaFirst: {
        type: String,
        required: false
      },
      selectedAreaSecond: {
        type: String,
        required: false
      },
      selectedAreaThird: {
        type: String,
        required: false
      },
      medicalDept: {
        type: Array,
        required: false
      },
      isTestCompany: {
        type: Boolean,
        required: false
      },
      hospitalName: {
        type: String,
        required: false
      },
      hospitalCeoName: {
        type: String,
        required: false
      },
      hospitalPhoneNumber: {
        type: String,
        required: false
      },
      hospitalCode: {
        type: String,
        required: false
      },
      doctors: {
        type: Array,
        required: false
      },
      businessNumber: {
        type: String,
        required: false
      },
      managerName: {
        type: String,
        required: false
      },
      managerDuty: {
        type: String,
        required: false
      },
      managerPhoneNumber: {
        type: String,
        required: false
      },
      managerId: {
        type: String,
        required: false
      },
      businessFileName: {
        type: String,
        required: false
      },
      businessFileData: {
        type: Object,
        required: false
      },
      businessImgUrl: {
        type: String,
        required: false
      },
      logoFileName: {
        type: String,
        required: false
      },
      logoFileData: {
        type: Object,
        required: false
      },
      logoImgUrl: {
        type: String,
        required: false
      },
      bannerFileName: {
        type: String,
        required: false
      },
      bannerFileData: {
      },
      bannerImgUrl: {
        type: String,
        required: false
      },
    }
  },
  // computed는 externalServiceMixin에서 관리 (showScheduleTypeSelect)
  async mounted() {
    this.initValues();
    this.getAreaList();
    await this.getDeptList();
    await this.getExternalServiceTypes();
  },
  watch : {
    data: {
      immediate: true,
      deep: true,
      async handler(newValue, oldValue) {
        if(newValue && newValue.hospitalId !== this.hospitalId) {
          this.initValues();
          this.getAreaList();
          await this.getDeptList();
        
          if(newValue.addrOne) this.selectedAreaFirst = newValue.addrOne;
          this.areaSecondChange();
          if(newValue.addrTwo) this.selectedAreaSecond = newValue.addrTwo;
          this.areaThirdChange();
          if(newValue.addrThree) this.selectedAreaThird = newValue.addrThree;
          if(newValue.addrDetail) {
            this.addrDetail = newValue.addrDetail;
          } else {
            this.addrDetail = '';
          }

          if(newValue.cNo) this.businessNumber = newValue.cNo;
          if(newValue.cNo) this.originalBusinessNumber = newValue.cNo;
          if(newValue.isTestCompany) this.isTestCompany = newValue.isTestCompany;
          if(newValue.cNoUrl) {
            this.businessImgUrl = newValue.cNoUrl;
            const businessUrlArray = newValue.cNoUrl.split("/");
            this.businessFileName = decodeUtfText(businessUrlArray[businessUrlArray.length - 1]);
          } 
          this.changeBusinessNumber();
          this.isBusinessNumberValid = true;
          
          if(newValue.call) this.hospitalPhoneNumber = newValue.call;
          this.changeHospitalPhoneNumber();
          if(newValue.ceo) this.hospitalCeoName = newValue.ceo;
          if(newValue.doctors && newValue.doctors.length > 0) this.doctors = newValue.doctors;
          if(newValue.hospitalCode) this.hospitalCode = newValue.hospitalCode;
          if(newValue.imgUrl) {
            this.logoImgUrl = newValue.imgUrl;
            const logoUrlArray = newValue.imgUrl.split("/");
            this.logoFileName = decodeUtfText(logoUrlArray[logoUrlArray.length - 1]);
          }
          console.log(newValue.bannerUrl);
          if(newValue.bannerUrl) {
            this.bannerImgUrl = newValue.bannerUrl;
            const bannerUrlArray = newValue.bannerUrl.split("/");
            this.bannerFileName = decodeUtfText(bannerUrlArray[bannerUrlArray.length - 1]);
          }
          if(newValue.hospitalId) this.hospitalId = newValue.hospitalId;
          if(newValue.medicalDept) this.medicalDept = newValue.medicalDept;
          if(newValue.name) this.hospitalName = newValue.name;

          // EMR 연동 정보 조회
          if(newValue.hospitalId) {
            // externalServiceTypes가 아직 로드되지 않았으면 먼저 로드
            if (!this.externalServiceTypes || this.externalServiceTypes.length === 0) {
              await this.getExternalServiceTypes();
            }
            await this.getEmrIntegration(newValue.hospitalId);
            // 챗봇 목록 조회
            await this.getChatbotList(newValue.hospitalId);
          }

          // 웹챗봇 설정 로드
          this.useWebChatbotOnReservation = newValue.useWebChatbotOnReservation || false;
          this.useOwnChatbot = newValue.useOwnChatbot || false;
          this.mainChatbotId = newValue.mainChatbotId || "";

          if(newValue.accountInfo && newValue.accountInfo.mobile) {
            this.managerPhoneNumber = newValue.accountInfo.mobile;
            this.changeManagerPhoneNumber();
          }
          if(newValue.accountInfo && newValue.accountInfo.name) this.managerName = newValue.accountInfo.name;
          if(newValue.accountInfo && !newValue.accountInfo.name) this.managerName = '';
          if(newValue.accountInfo && newValue.accountInfo.duty) this.managerDuty = newValue.accountInfo.duty;
          if(newValue.accountInfo && !newValue.accountInfo.duty) this.managerDuty = '';
          if(newValue.accountInfo && newValue.accountInfo.username) this.managerId = newValue.accountInfo.username;
          if(newValue.accountInfo && !newValue.accountInfo.username) this.managerId = '';
        }
        if(document.getElementById("logoPrevM")) document.getElementById("logoPrevM").src = this.logoImgUrl;
        if(document.getElementById("bannerPrevM")) document.getElementById("bannerPrevM").src = this.bannerImgUrl;
      },
    },    
  },
  methods: {
    changeHospitalPhoneNumber() {
      this.hospitalPhoneNumber = phoneNumberFormatter(this.hospitalPhoneNumber.toString());
    },
    changeManagerPhoneNumber() {
      this.managerPhoneNumber = phoneNumberFormatter(this.managerPhoneNumber.toString());
    },

    // 주요 API

    // 병원 정보 수정
    async modifyHospital() {
      if(await this.validateData()) {
        try {
          const obj = {};
          
          const deptArr = new Array();
          this.medicalDept.forEach((ele) => {
            deptArr.push(ele);
          });

          const doctorArr = new Array();
          const filteredArray = this.doctors.filter((element) => element !== "");
          if(filteredArray.length > 0) {
            filteredArray.forEach((ele) => {
              doctorArr.push(ele);
            });
          }

          obj.medicalDept = deptArr;       
          obj.name = this.hospitalName;
          if(this.hospitalCeoName) {
            obj.ceo = this.hospitalCeoName;
          } else {
            obj.ceo = '';
          } 

          obj.cNo = this.businessNumber.replace(/-/g, '');

          // 사용자가 사진을 올리지 않았으면 objectStorage 호출하지 않고 기존 url 보냄
          if(this.businessFileData) {
            const businessImgUrl = await this.uploadImageOnObjectStorage(this.businessFileData);
            obj.cNoUrl = businessImgUrl; 
          } else if(this.businessImgUrl) {
            obj.cNoUrl = this.businessImgUrl;
          } else {
            obj.cNoUrl = '';
          }
          if(this.logoFileData) {
            const logoImgUrl = await this.uploadImageOnObjectStorage(this.logoFileData);
            obj.imgUrl = logoImgUrl; 
          } else {
            obj.imgUrl = this.logoImgUrl;
          }
          console.log(this.bannerFileData);
          if(this.bannerFileData) {
            const bannerImgUrl = await this.uploadImageOnObjectStorage(this.bannerFileData);
            obj.bannerUrl = bannerImgUrl; 
          } else {
            obj.bannerUrl = this.bannerImgUrl;
          }
          console.log(obj.bannerUrl);
          
          obj.addrOne = this.selectedAreaFirst;
          obj.addrTwo = this.selectedAreaSecond;
          obj.addrThree = this.selectedAreaThird;
          obj.addrDetail = this.addrDetail;
          obj.isTestCompany = this.isTestCompany ? YnEnum.Y : YnEnum.N;

          if(this.hospitalPhoneNumber) {
            obj.call = this.hospitalPhoneNumber.replace(/-/g, '');
          } else {
            obj.call = '';
          };

          if(this.hospitalCode) {
            obj.hospitalCode = this.hospitalCode;
          } else {
            obj.hospitalCode = '';
          }
          obj.type = this.type;
          obj.doctors = doctorArr;

          const accountInfo = {};
          accountInfo.username = this.managerId;
          accountInfo.role = this.type;
          accountInfo.name = this.managerName;
          if(this.managerDuty) {
            accountInfo.duty = this.managerDuty;
          } else {
            accountInfo.duty = '';
          }
          if(this.managerPhoneNumber) {
            accountInfo.mobile = this.managerPhoneNumber.replace(/-/g, '');
          } else {
            accountInfo.mobile = '';
          } 
          
          obj.accountInfo = accountInfo;

          // 웹챗봇 설정
          obj.useWebChatbotOnReservation = this.useWebChatbotOnReservation;
          obj.useOwnChatbot = this.useOwnChatbot;
          if (this.useOwnChatbot && this.mainChatbotId) {
            obj.mainChatbotId = this.mainChatbotId;
          }

          // 외부 서비스 연동 정보 저장 (apiKey 변경 감지 포함)
          const currentApiKey = (this.apiKey || '').trim();
          const isApiKeyChanged = currentApiKey !== this.originalApiKey;
          const hasCredentials = currentApiKey || this.clientId || this.clientSecret;
          // 조건: 서비스 타입/서비스가 선택되었고, (credentials가 있거나 apiKey가 변경된 경우)
          const shouldSaveEmr = this.selectedServiceType && this.selectedService && (hasCredentials || isApiKeyChanged);

          if (shouldSaveEmr) {
            // DOCTOR_PALETTE인 경우 스케줄 종류 필수 검증
            if (this.showScheduleTypeSelect && !this.selectedScheduleType) {
              await openDialog("스케줄 종류를 선택해주세요.", "error", "확인");
              return;
            }

            try {
              await this.saveEmrIntegration(this.hospitalId, obj);
              // EMR 저장 성공 후 originalApiKey 업데이트
              this.originalApiKey = currentApiKey;
            } catch (emrError) {
              console.log('EMR 연동 저장 실패:', emrError);
              await openDialog("EMR 연동 설정 저장에 실패했습니다. 병원 정보 수정을 진행하지 않습니다.", "error", "확인");
              return; // EMR 저장 실패 시 병원 수정 중단
            }
          }

          const response = await this.$apiInstance.put(`/companies/${this.hospitalId}`, obj);
          if(response.status === 200 || response.status === 201) {
            // EMR 연동 정보가 있었는지 확인하여 메시지 다르게 표시
            const hasEmrIntegration = this.selectedServiceType && this.selectedService && (this.apiKey || this.clientId || this.clientSecret);
            const successMessage = hasEmrIntegration
              ? "병원 정보 수정 및 EMR 연동이 완료되었습니다."
              : "병원 정보 수정이 완료되었습니다.";

            await openDialog(successMessage, "success", "확인")
              .then(() => {
                location.reload();
              });
          } else {
            await openDialog("병원 정보 수정에 실패하였습니다.", "error", "확인");
          }

        } catch (error) {
          await openDialog("병원 정보 수정에 실패하였습니다.", "error", "확인");
          console.log(error);
        }
      } else {
      }
    },

    // 이미지 오브젝트스토리지에 업로드
    async uploadImageOnObjectStorage(fileData) {
      const response = await this.$apiInstance.post(`/object-storages`, fileData);
      if(response.status === 200 || response.status === 201) {
        return response.data.url;
      } else {
        return "";
      }
    },

    // 사업자등록번호 validate
    async businessNumberValidate() {
      const trimmedBusinessNumber = this.businessNumber.replace(/-/g, '');
      const businessNumberMsg = document.querySelector(".businessNumberMsgM");
      if (this.businessNumber.replaceAll('-','').length < 10) {
          businessNumberMsg.setAttribute("class", "businessNumberMsgM fail");
          businessNumberMsg.innerHTML = "잘못된 사업자등록번호입니다.";
          this.isBusinessNumberValid = false;
      } else {
        const response = await this.$apiInstance.get(`/companies/duplicateCheck/cNo/${trimmedBusinessNumber}`);
        if(response && (response.status === 200 || response.status === 201) && !response.data) {
          businessNumberMsg.setAttribute("class", "businessNumberMsgM success");
          businessNumberMsg.innerHTML = "사용할 수 있는 사업자등록번호입니다.";
          this.isBusinessNumberValid = true;
        } else if (this.originalBusinessNumber.replace(/-/g, '') === trimmedBusinessNumber) {
          businessNumberMsg.setAttribute("class", "businessNumberMsgM success");
          businessNumberMsg.innerHTML = "사용할 수 있는 사업자등록번호입니다.";
          this.isBusinessNumberValid = true;
        } else {
          businessNumberMsg.setAttribute("class", "businessNumberMsgM fail");
          businessNumberMsg.innerHTML = "이미 존재하는 사업자등록번호입니다.";
          this.isBusinessNumberValid = false;
        }
      }
    },

    // 파일첨부 창이 잘 안떠서 별도로 만든 클릭 메소드
    openBusinessFileInput() {
      this.$refs.businessFileInputM.click();
    },

    openLogoFileInput() {
      this.$refs.logoFileInputM.click();
    },
    openBannerFileInput() {
      console.log('openBannerFileInput')
      console.log(this.$refs)
      this.$refs.bannerFileInputM.click();
    },

    // 파일 형식 valitdate
    validateFile(file) {
      let result = true;
      if (
        file.type !== 'image/png' &&
        file.type !== 'image/jpeg' &&
        file.type !== 'image/jpg'
      ) {
        alert('png, jpeg, jpg 파일만 첨부 가능합니다.');
        result = false;
      } else if (changeBytesToKilos(file.size) > 100) {
        alert('파일 크기가 100MB를 초과합니다.');
        result = false;
      }

      return result;
    },

    
    validateFileSize(file) {
      let result = true;
      if (changeBytesToKilos(file.size) > 100) {
        alert('파일 크기가 100MB를 초과합니다.');
        result = false;
      }
      return result;
    },

    // 사업자등록증 이미지 onChange메소드
    changeBusinessNumImage() {
      const fileInput = document.getElementById("businessFileInputM");
      if (fileInput.files && fileInput.files[0]) {
        const validateFileSize = this.validateFileSize(fileInput.files[0]);
        if(validateFileSize) {
          this.businessFileName = fileInput.files[0].name;
          const formData = new FormData();
          formData.append("file", fileInput.files[0]);
          this.businessFileData = formData;
        }
      } 
    },
    deleteBusinessNumImage(){
      this.businessFileData = null;
      this.businessFileName = '';
      this.businessImgUrl = '';
    },

    // 로고 이미지 onChange메소드 및 미리보기
    changeLogoImage() {
      console.log('changeLogoImage')
      const fileInput = document.getElementById("logoFileInputM");
      console.log(fileInput.files);
      if (fileInput.files && fileInput.files[0]) {
        const validateFile = this.validateFile(fileInput.files[0]);
        if(validateFile) {
          const reader = new FileReader();
          reader.onload = function (e) {
            document.getElementById("logoPrevM").src = e.target.result;
          };
          reader.readAsDataURL(fileInput.files[0]);
          this.logoFileName = fileInput.files[0].name;
          document.getElementById("logoPrevM").classList.remove("hide");

          const formData = new FormData();
          formData.append("file", fileInput.files[0]);
          this.logoFileData = formData;
        };
      } else {
        document.getElementById("logoPrevM").src = "";
      }
    },
    changeBannerImage() {
      console.log('changeBannerImage')
      const fileInput = document.getElementById("bannerFileInputM");
      console.log('fileInput element:', fileInput)
      console.log('fileInput.files:', fileInput.files)
      console.log('fileInput.files.length:', fileInput.files ? fileInput.files.length : 'files is null')
      if (fileInput.files && fileInput.files[0]) {
        console.log('changeBannerImage')
        console.log(fileInput.files[0]);
        const validateFile = this.validateFile(fileInput.files[0]);
        if(validateFile) {
          const reader = new FileReader();
          reader.onload = function (e) {
            document.getElementById("bannerPrevM").src = e.target.result;
          };
          reader.readAsDataURL(fileInput.files[0]);
          this.bannerFileName = fileInput.files[0].name;
          document.getElementById("bannerPrevM").classList.remove("hide");

          const formData = new FormData();
          formData.append("file", fileInput.files[0]);
          this.bannerFileData = formData;
        };
      } else {
        document.getElementById("bannerPrevM").src = "";
      }
    },

    // 사업자등록증 다운로드
    downloadBusinessNumImage() {
      const fileInput = this.$refs.businessFileInputM;
      const file = fileInput.files[0];
      if (file) {
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(file);
        downloadLink.download = file.name;
        downloadLink.click();
      } else {
        const downloadLink = document.createElement("a");
        downloadLink.target = "_blank";
        downloadLink.href = this.businessImgUrl;
        downloadLink.download = this.businessFileName; 
        downloadLink.click();
      }
    },
    deleteLogoImage() {
      this.logoFileData = null;
      this.logoFileName = '';
      this.logoImgUrl = '';
      document.getElementById("logoPrevM").src = "";
    },
    deleteBannerImage() {
      this.bannerFileData = null;
      this.bannerFileName = '';
      this.bannerImgUrl = '';
      document.getElementById("bannerPrevM").src = "";
    },
    // 로고 이미지 다운로드
    downloadLogoImage() {
      const fileInput = this.$refs.logoFileInputM;
      const file = fileInput.files[0];
      if (file) {
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(file);
        downloadLink.download = file.name;
        downloadLink.click();
      } else {
        const downloadLink = document.createElement("a");
        downloadLink.target = "_blank";
        downloadLink.href = this.logoImgUrl;
        downloadLink.download = this.logoFileName; 
        downloadLink.click();
      }
    },
    downloadBannerImage() {
      console.log('downloadBannerImage')
      const fileInput = this.$refs.bannerFileInputM;
      const file = fileInput.files[0];
      if (file) {
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(file);
        downloadLink.download = file.name;
        downloadLink.click();
      } else {
        const downloadLink = document.createElement("a");
        downloadLink.target = "_blank";
        downloadLink.href = this.bannerImgUrl;
        downloadLink.download = this.bannerFileName; 
        downloadLink.click();
      }
    },
    // 업로드 전 검증
    async validateData() {
      let result = true;
      if (this.medicalDept.length === 0) {
        await openDialog("진료 과목을 선택해 주세요.", "error", "확인");
        result = false;
      } else if( !this.selectedAreaFirst ||
        !this.selectedAreaSecond) {
        await openDialog("병원 지역을 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.hospitalName) {
        await openDialog("병원 이름을 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.businessNumber) {
        await openDialog("사업자등록번호를 입력해 주세요.", "error", "확인");
        result = false;
      } else if (this.businessNumber.replaceAll('-','').length < 10) {
        await openDialog("사업자등록번호를 올바르게 입력해 주세요.", "error", "확인");
        result = false;
      } else if(!this.isBusinessNumberValid) {
        await openDialog("사업자등록번호 중복확인을 해 주세요.", "error", "확인");
        result = false;
      } 
      return result;
    },

    // 기타 HospitalInfoM용 utils

    // 항목 초기화 용도
    initValues() {
      this.hospitalName = "";
      this.hospitalCeoName = "";
      this.hospitalPhoneNumber = "";
      this.hospitalCode = "";
      this.businessNumber = "";
      this.managerName = "";
      this.managerPhoneNumber = "";
      this.managerId = "";
      this.logoImgUrl = "";
      this.bannerImgUrl = "";
      this.businessImgUrl = "";
      this.logoFileData = null;
      this.businessFileData = null;
      this.doctors = [""];
      this.selectedAreaFirst = "";
      this.selectedAreaSecond = "";
      this.selectedAreaThird = "";
      this.addrDetail = "";
 
      let bFileInput;
      if(document.getElementById("businessFileInputM")) {
        bFileInput = document.getElementById("businessFileInputM").value;
        if (!bFileInput.length || bFileInput === "") {
          this.businessFileName = "";
        }
      }

      let lFileInput;
      if(document.getElementById("logoFileInputM")) {
        lFileInput = document.getElementById("logoFileInputM").value;
        if (!lFileInput.length || lFileInput === "") {
          this.logoFileName = "";
        }
      }

      let bannerFileInput;
      if(document.getElementById("bannerFileInputM")) {
        bannerFileInput = document.getElementById("bannerFileInputM").value;
        if (!bannerFileInput.length || bannerFileInput === "") {
          this.bannerFileName = "";
        }
      }

      if(document.getElementById("logoPrevM")) document.getElementById("logoPrevM").src = "";
      if(document.getElementById("bannerPrevM")) document.getElementById("bannerPrevM").src = "";
      if(document.querySelector(".businessNumberMsgM")) document.querySelector(".businessNumberMsgM").innerHTML = "";

      // 외부 서비스 필드 초기화 (mixin 메서드 사용)
      this.initExternalServiceValues();

      // 웹챗봇 설정 초기화
      this.useWebChatbotOnReservation = false;
      this.useOwnChatbot = false;
      this.mainChatbotId = "";
      this.chatbotList = [];
    },

    // 병원코드, 의료종사자번호, 사업자등록번호(중복확인 필요한 값들)의 값 변경 시 valid false로 재설정
    changeBusinessNumber(e) {
      this.businessNumber = businessNumberFormatter(this.businessNumber);
      this.isBusinessNumberValid = false;
      if(document.querySelector(".businessNumberMsgM")) document.querySelector(".businessNumberMsgM").innerHTML = "";
    },


    // 기타 HospitalInfoM용 utils

    // 지역 목록 가져오기
    getAreaList() {
      this.areaFirst = Object.keys(jsonFile).sort((a, b) => a.localeCompare(b, 'ko-KR'));
      this.selectedAreaFirst = "";
      this.selectedAreaSecond = "";
      this.selectedAreaThird = "";
    },

    // 시도 변화에 따른 시군구 값 넣기
    areaSecondChange() {
      if(this.selectedAreaFirst) {
        const secondLevelData = jsonFile[this.selectedAreaFirst];
        if(secondLevelData) {
          this.areaSecond = Object.keys(secondLevelData).sort((a, b) => a.localeCompare(b, 'ko-KR'));
          this.selectedAreaSecond = '';
          this.selectedAreaThird = '';
          this.areaThird = [];
        } else {
          this.selectedAreaSecond = '';
          this.selectedAreaThird = '';
          this.areaSecond = [];
          this.areaThird = [];
        }
      } else {
        this.selectedAreaSecond = "";
        this.selectedAreaThird = "";
        this.areaSecond = [];
        this.areaThird = [];
      }
    },

    // 시군구 변화에 따른 읍면동 값 넣기
    areaThirdChange() {
      if (this.selectedAreaSecond) {
        if(!jsonFile[this.selectedAreaFirst]) {
          this.selectedAreaThird = '';
          this.areaThird = [];
          return;
        }
        const thirdLevelData =
          jsonFile[this.selectedAreaFirst][this.selectedAreaSecond];
          if(thirdLevelData) {
            this.areaThird = Object.keys(thirdLevelData).sort((a, b) => a.localeCompare(b, 'ko-KR'));
            this.selectedAreaThird = '';
          } else {
            this.selectedAreaThird = '';
            this.areaThird = [];
          }
      } else {
        this.selectedAreaThird = '';
        this.areaThird = [];
      }
    },

    // 과 목록 가져오기
    async getDeptList() {
      try {
        const response = await this.$apiInstance.get(`/items/medical/depts`);
        if(response.status === 200 || response.status === 201) {
          this.deptList = response.data.filter(item => item.code !== MedicalDept.COMMON);
        }
      } catch(error) {
        console.log(error);
      }
    },
    // 의사 추가
    addRow() {
      this.doctors.push("");
    },
    // 의사 삭제
    deleteRow(index) {
      this.doctors.splice(index, 1);
    },
    // 외부 서비스 관련 메서드는 externalServiceMixin에서 관리

    // 웹챗봇 관련 메서드
    async getChatbotList(companyId) {
      try {
        console.log('getChatbotList 호출, companyId:', companyId);
        const response = await this.$apiInstance.get(`/companies/${companyId}/chatbots`);
        console.log('챗봇 목록 응답:', response.data);
        if (response.status === 200 || response.status === 201) {
          this.chatbotList = response.data.chatbots || [];
          console.log('chatbotList 설정됨:', this.chatbotList);
        }
      } catch (error) {
        console.log('챗봇 목록 조회 실패:', error);
        this.chatbotList = [];
      }
    },
    onUseWebChatbotChange(checked) {
      if (!checked) {
        this.useOwnChatbot = false;
        this.mainChatbotId = "";
      }
    },
    onUseOwnChatbotChange(checked) {
      if (!checked) {
        this.mainChatbotId = "";
      }
    },
  },
};
</script>
